import { useCallback } from "react";
import s from "./index.module.css";
import { ClassItem } from "@/service";

interface Props {
  item: ClassItem;
  currId: number | undefined;
  setCurrClass?: (item: ClassItem) => void;
}

const Item: React.FC<Props> = ({ item, currId, setCurrClass }) => {
  const handleClick = useCallback(() => {
    setCurrClass && setCurrClass(item);
  }, [setCurrClass]);

  return (
    <div
      key={item.courseId}
      className={`${s.item} ${currId === item.courseId ? s.active : ""}`}
      onClick={handleClick}
    >
      <div>{item.courseName}</div>
      <div className={s.secondLine}>
        <div className={s.strong}>开课时间: {item.startTime}</div>
        {item.teacherName && <div>{item.teacherName}</div>}
      </div>
      <div>已有学员：{item.studentNum || 0}</div>
    </div>
  );
};

export default Item;
